<template>
  <div class="home-page">

    <!-- Navbar -->
    <navbar-home></navbar-home>

    <!-- Sección principal con logo -->
    <section class="home-intro d-flex align-items-center">
      <div class="container">
        <div class="row align-items-center">

          <!-- Texto principal -->
          <div class="col-md-6 text-center text-md-left mb-4 mb-md-0">
            <h1 class="home-title">Tus envíos en manos de especialistas</h1>
            <p class="home-subtitle">
              Simplificamos tu logística trabajando con los mejores transportistas.
              Envía con seguridad y eficiencia a través de nuestra plataforma.
            </p>
            <router-link class="btn btn-primary btn-lg mt-3 home-cta" to="/dashboard/shipment/new"
              v-help="'Al dar clic serás redirigido al cotizador de envíos'">
              Cotiza tu envío ahora
            </router-link>
          </div>

          <!-- Imagen decorativa -->
          <div class="col-md-6 text-center">
            <img src="@/assets/images/sack/logo.png" class="img-fluid rounded shadow-sm home-image"
              alt="Entrega rápida">
          </div>

        </div>
      </div>
    </section>

    <!-- Sección de servicios destacados -->
    <section class="home-services py-5 bg-light">
      <div class="container">
        <h2 class="text-center mb-5">Nuestros servicios</h2>
        <div class="row text-center">
          <div class="col-md-4 mb-4" v-for="(service, i) in services" :key="i">
            <div class="service-card p-4 rounded shadow-sm hover-scale" v-help="service.description">
              <h5>{{ service.title }}</h5>
              <p>{{ service.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Footer global -->
    <AppFooter />
  </div>
</template>

<style scoped>
.home-intro {
  min-height: 70vh;
  display: flex;
  align-items: center;
  background: linear-gradient(to right, #f8f9fa 0%, #ffffff 100%);
  padding: 60px 0;
}

.home-title {
  font-size: 2.8rem;
  font-weight: 700;
  line-height: 1.2;
  color: #2c2e78;
}

.home-subtitle {
  font-size: 1.125rem;
  color: #5a5a5a;
  margin-top: 1rem;
}

.home-cta {
  transition: transform 0.2s, box-shadow 0.2s;
}

.home-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(232, 12, 74, 0.25);
}

.home-image {
  max-width: 100%;
  border-radius: 0.5rem;
}

.home-services h2 {
  color: #2c2e78;
  font-weight: 700;
}

.service-card {
  background: #ffffff;
  transition: transform 0.3s, box-shadow 0.3s;
}

.hover-scale:hover {
  transform: translateY(-6px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.service-card h5 {
  font-weight: 600;
  color: #e80c4a;
  margin-bottom: 0.5rem;
}

.service-card p {
  color: #6c757d;
}
</style>


<script>
import AppFooter from "@/components/AppFooter.vue";
import NavbarHome from "./Header/NavbarHome";

export default {
  name: "Home",
  components: {
    AppFooter,
    "navbar-home": NavbarHome
  },
  data() {
    return {
      services: [
        { title: "Envíos Express", description: "Entrega rápida y segura a nivel nacional." },
        { title: "Seguimiento en tiempo real", description: "Monitorea cada paso de tu envío desde tu panel." },
        { title: "Soporte dedicado", description: "Atención personalizada para resolver cualquier duda." },
      ]
    };
  },
  mounted() {
    const keepSession = localStorage.getItem("keep-session");
    if (!keepSession) {
      localStorage.clear();
      this.$router.push("/signin");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home.vue